
const BASE_URL = "https://zinger.prod-rasiinfotech.in";
const WEB_URL  = "https://vclive.prod-rasiinfotech.in";

// const WEB_URL  = "https://trysumangaleejewellers.in";
// const BASE_URL = "https://froads.trysumangaleejewellers.in";

// const WEB_URL  = "https://shop.prod-rasiinfotech.in";
// const BASE_URL = "https://demo.prod-rasiinfotech.in";

export { BASE_URL , WEB_URL};
